import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { ReporteFactura } from 'src/app/models/bills-to-online-payment.model';
import { PaymentsService } from 'src/app/services/payments.service';
import { TableHeadingsService } from '../../../services/table-headings.service';
import { BackEndService } from 'src/app/services/back-end.service';
import { OrdenModel } from 'src/app/models/orden.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { PayzenModel } from 'src/app/models/payzen.model';

import Swal from "sweetalert2";
import { ResponseModel } from 'src/app/models/response.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-bills-online-payment',
  templateUrl: './bills-online-payment.component.html',
  styleUrls: ['./bills-online-payment.component.scss']
})
export class BillsOnlinePaymentComponent implements OnInit {

  @Input() mobile: boolean = false;
  @Input() dataBills: ReporteFactura[] = [];
  public billToPayment: ReporteFactura;
  public OrdenPago: any;
  public Orden = new OrdenModel();
  public Payzen = new PayzenModel();
  public PayzenResponse: Array<ResponseModel> = [];
  public togglePayzen = false;
  public toggleBotonPayzen = false;

  public billSelected = null;

  public spinnerText = "Espere por favor";

  constructor(
    private paymentsService: PaymentsService,
    public tableHeadingsService: TableHeadingsService,
    private backend: BackEndService,
    private spinner: NgxSpinnerService,
    private el: ElementRef
  ) { }

  ngOnInit() {
    this.getBillsToPayment();
  }

  getBillsToPayment() {
    this.paymentsService.getBillsToPayment().subscribe((response: ReporteFactura[]) => {
      this.dataBills = response;
      console.log(this.dataBills);

    }, (error: any) => {
      this.dataBills = [];
      console.log('error bills to pay', error);
    });
  }

  Redireccion() {
    this.spinnerText = "Redireccionando a Payzen";
    this.spinner.show();
  }

  GetOrdenPago() {
    this.spinner.show();
    
    this.GetPayzen();
  }

  GetPayzen(orden?: string) {
    this.Orden.valor_pagado = this.billToPayment.MORA_FINAL;
    this.Orden.obligacion = this.billToPayment.NUMERO_FACTURA.toUpperCase();
    this.Orden.id_pais = "10";
    // Orden pago
    this.Orden.documento = this.billToPayment.DOCUMENTO;
    this.Orden.tipo_documento = this.billToPayment.TIPO_DOCUMENTO;
    this.Payzen.id_pais = '10';
    this.Payzen.documento = this.Orden.documento;
    this.Payzen.tipo_documento = this.Orden.tipo_documento;
    this.Payzen.vads_amount = this.Orden.valor_pagado;
    this.Payzen.vads_cust_id = this.Orden.documento;
    this.Payzen.vads_cust_email = 'test@covinoc.com';
    this.Payzen.factura = true;
    this.Payzen.vads_order_id = this.billToPayment.NUMERO_FACTURA;
    this.Payzen.vads_shop_name = 'suCovirecupera';
    this.Payzen.vads_url_return = environment.urlReturn;
    this.Payzen.vads_shop_url = environment.shopUrl;

    this.backend.GetPayzen(this.Payzen).subscribe(
      (resp: any) => {
        this.spinner.hide();
        /* 
          {
              icon: 'error',
              title: 'Servicio no disponible.',
              text: 'Por favor intente más tarde.',
              allowOutsideClick: false,
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'Aceptar'
            }
          
         */
        if (!resp || (resp && resp[0] && resp[0].key === "ERRROR") || (Array.isArray(resp) && !resp.length)) {
          Swal.fire(
            'Servicio no disponible, por favor intente mas tarde.'
          ).then(() => {
            this.spinner.hide();
            location.reload();
          });

          return;
        }
        this.togglePayzen = true;
        // Setear valores al formulario hidden
        this.PayzenResponse = resp;
        console.log(this.PayzenResponse);


        // El formulario no puede ser enviado con valor $0 en el vads_amount
        const vads_amount_ok = this.PayzenResponse.filter((input: any) => input.key === 'vads_amount')
          .map((vadsInput: any) => Number(vadsInput.value) > 0)[0] || false;

        console.log(vads_amount_ok);

        if (vads_amount_ok === true) {
          this.toggleBotonPayzen = true;
          /* this.el.nativeElement.scrollTop += */
        }
        /* 
          {
            icon: 'error',
            title: 'No se puede procesar el pago.',
            text: '',
            allowOutsideClick: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Aceptar'
          }
         */
        if (vads_amount_ok !== true) {
          Swal.fire('No se puede procesar el pago. Valor no puede ser $0 pesos.').then(() => {
            this.spinner.hide();
            location.reload();
          });
        }

      },
      (err: any) => {
        this.spinner.hide();
        this.togglePayzen = false;
        console.error(err);
        /* 
          {
          icon: "error",
          title: "Error",
          text: "Al redirigir a Payzen",
          allowOutsideClick: false
        }
         */
        Swal.fire('Error redireccionando a Payzen');
      },
      () => {
        this.spinner.hide();
      }
    );
  }


  handleOnlinePayment(bill: ReporteFactura, index) {
    console.log('bill', bill);
    this.billToPayment = bill;
    this.billSelected =  index;
    this.GetOrdenPago();
  }

}
